import { Component, Inject } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SingleEntryDialogResult {
  result: boolean;
  value?: string;
}

@Component({
    selector: 'single-entry-dialog',
    templateUrl: './single-entry-dialog.component.html',
    standalone: false
})
export class SingleEntryDialogComponent {
  public formGroup: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<SingleEntryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleEntryDialogModel) {
    this.formGroup = new UntypedFormGroup({ formControl: new UntypedFormControl(data.defaultValue || null, Validators.required) });
  }

  onFocus() {
    this.formGroup.get('formControl')?.markAsUntouched();
  }

  onConfirm(): void {
    if (this.formGroup.valid) {
      const dialogResult: SingleEntryDialogResult = { result: true, value: this.formGroup.get('formControl')?.value };
      this.dialogRef.close(dialogResult);
    }
  }

  onCancel(): void {
    const dialogResult: SingleEntryDialogResult = { result: false };
    this.dialogRef.close(dialogResult);
  }
}

export class SingleEntryDialogModel {

  constructor(public title: string, public formControlLabel: string, public validationErrorMessage: string, public defaultValue?: string) {
  }
}
